import React from "react";
import { Card, TabWrapper, TabItem } from "legion-ui";

const TabbarVertical = () => {
  return (
    <div style={{ marginBottom: '30px', width: '630px' }}>
      <Card style={{ paddingLeft: '24px' }}>
        <TabWrapper style={{ marginRight: '24px' }} variant="vertical" tabName="tabTwo">
          <TabItem id="tab10" label="Product" isActive={true} />
          <TabItem id="tab11" label="Detail" icon='Info' />
          <TabItem id="tab12" label="Variant" />
          <TabItem id="tab13" label="Color Option" badgeNumber='4' />
        </TabWrapper>
      </Card>
    </div>
  );
};

export default TabbarVertical;
